import { Reveal } from "./Reveal";

const shots = [
  {
    src: "/gallery4.jpg",
    title: "V2 Max",
    desc: "",
    span: "md:col-span-2 md:row-span-2",
    pos: "object-[50%_100%]",
    big: true,
  },
  {
    src: "/gallery2.jpg",
    title: "Neoprén rugóhuzatok",
    desc: "Csökkentik a zajt, egyenletes rugónyúlást biztosítanak, és biztos fogást adnak a rugók cseréjekor.",
    contain: true,
  },
  {
    src: "/gallery3.jpg",
    title: "Visszahúzódó kötélrendszer",
    desc: "Önfeltekerő kötéldobok és önzáró rögzítők. Gyors, precíz kötélállítást tesznek lehetővé edzés közben.",
  },
  {
    src: "/gallery6.jpg",
    title: "Kerekek és csúszásgátló talpak",
    desc: "A reformer könnyen mozgatható, a tartós szilikonos PVC talpak pedig minden padlón stabilan a helyén tartják.",
    pos: "object-[50%_92%]",
  },
  {
    src: "/gallery5.jpg",
    title: "Komfort lábtartó rúd",
    desc: "A párnázott lábtartó kényelmesebb, és kevésbé terheli a kezet és a lábfejet gyakorlás közben.",
  },
];

export const Gallery = () => (
  <section id="galeria" className="py-24 lg:py-32 bg-[var(--stone-bg2)]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="eyebrow text-[var(--terra)] mb-4">Részletek</p>
        <h2 className="font-serif-d font-medium text-2xl sm:text-3xl lg:text-4xl max-w-xl leading-tight">
          A minőség a részletekben rejlik.
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-4 gap-x-4 gap-y-8" data-testid="gallery-grid">
        {shots.map((s, i) => (
          <Reveal key={s.src} delay={i * 0.07} className={s.span || ""}>
            <div className="flex flex-col h-full">
              <figure
                className={`group relative overflow-hidden rounded-2xl ${
                  s.big ? "flex-1 min-h-[24rem] md:min-h-0" : "h-72 md:h-80"
                } ${s.contain ? "bg-[#0e0e0e]" : ""}`}
              >
                <img
                  src={s.src}
                  alt={s.title}
                  className={`absolute inset-0 w-full h-full transition-transform duration-700 group-hover:scale-105 ${
                    s.contain ? "object-contain" : "object-cover"
                  } ${s.pos || ""}`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-5 pt-12">
                  {s.big ? (
                    <p className="font-serif-d font-semibold text-2xl text-white">{s.title}</p>
                  ) : (
                    <p className="eyebrow text-white">{s.title}</p>
                  )}
                </figcaption>
              </figure>
              {s.desc && (
                <p className="mt-3 text-xs text-[var(--ink-muted)] leading-relaxed">{s.desc}</p>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
